// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"213":"2f514843","439":"a04b3a9e","451":"a04b3a9e","777":"b1a127d5"}[chunkId] + ".chunk.css";
};